import { PaddedSurface } from "App/global-style";
import React from "react";
import { CarProductIntroFormValues } from "./interfaces";

import { DropdownContent } from "Components/DropdownContent";
import { ContactUsAlert } from "Components/Form/Alert";
import { useTexts } from "Components/TextContext";
import { AlertTitle } from "Components/TextContext/commonComponentEnums";
import { useFeatureToggle } from "Store/featureToggles/featureToggleHooks";
import { FeatureToggle } from "Store/featureToggles/featureToggleTypes";
import { useFormikContext } from "formik";
import { FindManualVehicle } from "./FindManualVehicle";
import { OwnedVehicles } from "./OwnedVehicles";
import { useViewModel } from "./OwnedVehicles/hooks";
import {
  useHandleCarInfoUpdates,
  useHandleDefaultsForCustomerWithoutOwnedVehicles,
} from "./hooks";

export const FormElements = (): React.ReactElement => {
  const { getText } = useTexts();
  const formProps = useFormikContext<CarProductIntroFormValues>();
  const blockingPage = useFeatureToggle(FeatureToggle.BLOCKING_PAGE);

  const {
    data: {
      vehicles,
      isLoading: isLoadingVehicles,
      renderView: shouldShowOwnedVehicles,
    },
  } = useViewModel();

  useHandleDefaultsForCustomerWithoutOwnedVehicles();
  useHandleCarInfoUpdates();

  const doesCustomerHaveOwnedVehicles =
    shouldShowOwnedVehicles && vehicles.length > 0;

  const shouldShowContactUsAlert =
    formProps.values.isAlreadyInsured !== true &&
    formProps.values.canBeBoughtOnline === false &&
    !blockingPage;

  return (
    <>
      <PaddedSurface>
        <OwnedVehicles />
        {!isLoadingVehicles && doesCustomerHaveOwnedVehicles && (
          <>
            <DropdownContent
              buttonText={getText("carform.button.searchforyourcar")}
            >
              <>
                <br />
                <FindManualVehicle />
              </>
            </DropdownContent>
          </>
        )}
        {!isLoadingVehicles && !doesCustomerHaveOwnedVehicles && (
          <FindManualVehicle displayTitle={false} />
        )}
      </PaddedSurface>

      {shouldShowContactUsAlert && (
        <ContactUsAlert
          title={getText(AlertTitle.CALL_US)}
          description={getText(
            "carform.alertdescription.brand-cant_buy_online",
          )}
          alertId="vehicleCantBeBoughtOnline"
          variant="border"
          marginBottom="32px"
        />
      )}
    </>
  );
};
